<template>
  <section
    class="mx-auto flex h-full w-full flex-col no-underline"
    :class="[
      bgColorClass,
      customClasses,
      widthClass,
      hoverClass,
      { shadow: hasDropShadow },
    ]">
    <slot>
      <div class="bg-light-gray h-72 w-full"></div>
    </slot>
  </section>
</template>

<script>
import { computed } from "@vue/runtime-core";
import {
  useIsBgColor,
  useCustomValidator,
} from "../../../compostables/useValidators";

export default {
  props: {
    bgColor: {
      type: String,
      required: false,
      default: "white",
      validator(value) {
        return useIsBgColor(value);
      },
    },
    customClasses: {
      type: Array,
      required: false,
    },
    hasDropShadow: {
      type: Boolean,
      required: false,
      default: true,
    },
    fullWidth: {
      type: Boolean,
      default: false,
      required: false,
    },
    size: {
      type: String,
      required: false,
      default: "large",
      validator(value) {
        return useCustomValidator(["small", "normal", "large"], value);
      },
    },
    isLink: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup(props) {
    const bgColorClass = computed(() => ({
      "bg-white": props.bgColor === "white",
      "bg-light-blue-2 border border-light-blue-2-600":
        props.bgColor === "blue",
      "bg-light-gray-400 border border-light-gray-600":
        props.bgColor === "gray",
      "bg-orange-100 border border-light-gray-600": props.bgColor === "orange",
    }));

    const widthClass = computed(() => ({
      "sm-max:max-w-sm md:max-w-lg xl:max-w-2xl": !props.fullWidth,
    }));

    const hoverClass = computed(() => ({
      "hover:bg-light-gray-400 focus:bg-light-gray-400 transition duration-300":
        props.isLink,
    }));

    return {
      bgColorClass,
      // sizeClass,
      widthClass,
      hoverClass,
    };
  },
};
</script>

<style></style>
